<div *ngIf="this.loader.loading | async" class="spinner-container">
    <div  class="loadingSet">
        <div class="loaderImg">
            <img src="./images/loading.gif" />
        </div>
        loading...
    </div>
</div>
